/**
 * Router definition for the Quality Domination web app.
 *
 * Routes:
 *   /                              Home — Create / Join entry
 *   /create                        Pre-lobby settings (admin-side)
 *   /game/:sessionId/lobby         Lobby (admin or player view via ?role=)
 *   /join                          Code entry
 *   /join/:sessionId               Direct join (QR scan target)
 *   /game/:sessionId/play          Phase 4 stub
 */

import { createBrowserRouter } from 'react-router-dom';
import { Home } from './Home';
import { Create } from './Create';
import { Lobby } from './Lobby';
import { JoinByCode } from './JoinByCode';
import { JoinDirect } from './JoinDirect';
import { Play } from './Play';
import { MapPreview } from './MapPreview';

export const router = createBrowserRouter([
  { path: '/', element: <Home /> },
  { path: '/create', element: <Create /> },
  { path: '/game/:sessionId/lobby', element: <Lobby /> },
  { path: '/join', element: <JoinByCode /> },
  { path: '/join/:sessionId', element: <JoinDirect /> },
  { path: '/game/:sessionId/play', element: <Play /> },
  { path: '/map-preview', element: <MapPreview /> },
]);
